import { createGenericDispatcher } from '../../action/action-dispatcher-factory';
import { visitDetailsStateForContactIdSelector } from '../shortened-url-selectors';

import * as Api from '../../api/api';

export const loadShortenedUrlVisits = (contactId: number) =>
  createGenericDispatcher({
    name: 'LOAD_SHORTENED_URL_VISITS',
    loadFunction: () => Api.get(`/shortened-url/visits?contactId=${contactId}`),
    args: { contactId },
    shouldExecuteSelector: (state: any) => visitDetailsStateForContactIdSelector(state, contactId),
  });
